import React from 'react';

import PropTypes from 'prop-types';
import {
  ValidatedTextInputV2,
  TextInputV2,
  Visible,
  Spacer,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message, Dropdown, Button } from 'src/core/components';

import { FormTitle, MoreInfo } from './components';
import {
  rnaTypeOptions,
  overhangOptions,
  purityOptions,
  getSenseOptions,
  getScaleOptions
} from './configs';
import {
  OLIGO_NAME,
  RESEARCHER_NAME,
  RNA_TYPE,
  SENSE_SEQUENCE,
  SENSE_MODIFICATION,
  OVERHANG,
  ANTISENSE_SEQUENCE,
  SCALE,
  PURITY,
} from './constants';
import messages from './messages';
import './OligosForm.scss';

const OligosFormComponent = ({
  isJapan,
  formData,
  onChangeField,
  onChangeSenseSequence,
  validators,
  onAddToCart,
  addToCartAvailable,
  isSiRNASelected
}) => (
  <>
    <div className="oligos-form-wrapper">
      <FormTitle isJapan={isJapan} />
      {/* <HPLCPurification /> */}
      <div className="forms-wrapper-oliogs">
        <div className="names-wrapper">
          <ValidatedTextInputV2
            className="form-input"
            label={<Message message={messages.oligoName} />}
            required
            showOnlyOneError
            validators={validators[OLIGO_NAME]}
            value={formData[OLIGO_NAME]?.value}
            onChange={(value, e, canValidate, isValid) => onChangeField(OLIGO_NAME, value, isValid)}
          />
          <ValidatedTextInputV2
            className="form-input"
            label={<Message message={messages.researcherName} />}
            required
            showOnlyOneError
            validators={validators[RESEARCHER_NAME]}
            value={formData[RESEARCHER_NAME]?.value}
            onChange={
              (value, e, canValidate, isValid) => onChangeField(RESEARCHER_NAME, value, isValid)
            }
          />
        </div>
        <div className="types-rna">
          <Dropdown
            id="types-rna-dropdown"
            label={messages.typesOfRNA}
            required
            options={rnaTypeOptions}
            placeholder={messages.typesOfRNA}
            onSelect={(value) => onChangeField(RNA_TYPE, value, true)}
            selectedValue={formData[RNA_TYPE]?.value}
          />
        </div>
      </div>

      <div className="sense-wrapper">
        <div>
          <ValidatedTextInputV2
            className="form-input-textarea"
            label={<Message message={messages.senseSequence} />}
            required
            textarea
            validators={validators[SENSE_SEQUENCE]}
            showOnlyOneError
            value={formData[SENSE_SEQUENCE]?.value}
            onChange={onChangeSenseSequence}
          />
          <Spacer top="7" />
          <div className="base-count">
            <Message message={{
              ...messages.baseCount,
              values: { count: formData[SENSE_SEQUENCE]?.value?.length },
            }}
            />
          </div>
        </div>

        <Visible when={isSiRNASelected}>
          <div className="sense-wrapper__overhang-modification-wrapper">
            <Dropdown
              id="sense-dropdown"
              options={getSenseOptions()}
              label={messages.senseModification}
              placeholder={messages.senseModification}
              onSelect={(value) => onChangeField(SENSE_MODIFICATION, value, true)}
              selectedValue={formData[SENSE_MODIFICATION]?.value}
            />

            <Dropdown
              id="overhang-dropdown"
              options={overhangOptions}
              label={messages.overhang}
              placeholder={messages.overhang}
              onSelect={(value) => onChangeField(OVERHANG, value, true)}
              selectedValue={formData[OVERHANG]?.value}
            />
          </div>
        </Visible>
      </div>

      {/* <Visible when={isSiRNASelected}>
        <Checkbox
          id="duplex-checkbox"
          onChange={() => onChangeField(DUPLEX, !formData[DUPLEX]?.value, true)}
          value={formData[DUPLEX]?.value}
          checked={formData[DUPLEX]?.value}
          data-testid="duplex"
        >
          <Message message={messages.duplex} />
        </Checkbox>
      </Visible> */}

      <Visible when={!isSiRNASelected}>
        <div className="sense-wrapper">
          <div>
            <TextInputV2
              className="form-input-textarea"
              label={<Message message={messages.antisenseSequence} />}
              required
              textarea
              readonly
              value={formData[ANTISENSE_SEQUENCE]?.value}
            />
            <div className="base-count">
              <Message message={{
                ...messages.antisenseBaseCountMessage,
                values: { count: formData[ANTISENSE_SEQUENCE]?.value?.length },
              }}
              />
            </div>
          </div>
        </div>
      </Visible>

      {/* <Visible when={formData[DUPLEX]?.value && isSiRNASelected}>
        <div className="sense-wrapper">
          <div>
            <TextInputV2
              className="form-input-textarea"
              label={<Message message={messages.antisenseSequence} />}
              required
              textarea
              readonly
              value={formData[ANTISENSE_SEQUENCE]?.value}
            />
            <div className="base-count">
              <Message message={{
                ...messages.antisenseBaseCountMessage,
                values: { count: formData[ANTISENSE_SEQUENCE]?.value?.length },
              }}
              />
            </div>
          </div>

          <Visible when={isSiRNASelected}>
            <div className="sense-wrapper__overhang-modification-wrapper">
              <Dropdown
                id="sense-dropdown-duplex"
                options={getSenseOptions()}
                label={messages.senseModification}
                placeholder={messages.senseModification}
                onSelect={(value) => onChangeField(ANTISENSE_MODIFICATION, value, true)}
                selectedValue={formData[ANTISENSE_MODIFICATION]?.value}
              />

              <Dropdown
                id="overhang-dropdown-duplex"
                options={overhangOptions}
                label={messages.overhang}
                placeholder={messages.overhang}
                onSelect={(value) => onChangeField(ANTISENSE_OVERHANG, value, true)}
                selectedValue={formData[ANTISENSE_OVERHANG]?.value}
              />
            </div>
          </Visible>
        </div>
      </Visible> */}

      <div className="scale-purity-wrapper">
        <Dropdown
          id="scale-dropdown"
          label={messages.scale}
          required
          options={getScaleOptions(formData[SENSE_MODIFICATION]?.value)}
          placeholder={messages.scale}
          onSelect={(value) => onChangeField(SCALE, value, true)}
          selectedValue={formData[SCALE]?.value}
        />

        <div>
          <Dropdown
            id="purity-dropdown"
            label={messages.purity}
            required
            options={purityOptions}
            placeholder={messages.purity}
            onSelect={(value) => onChangeField(PURITY, value, true)}
            selectedValue={formData[PURITY]?.value}
          />
          <MoreInfo />
        </div>

        <div>
          <Button
            data-testid="add-to-cart-btn"
            className="add-to-cart-btn"
            type="primary"
            onClick={onAddToCart}
            label={messages.addToCart}
            disabled={!addToCartAvailable}
          />
        </div>
      </div>
    </div>
  </>
);

OligosFormComponent.propTypes = {
  formData: PropTypes.object.isRequired,
  onChangeField: PropTypes.func.isRequired,
  validators: PropTypes.object.isRequired,
  onChangeSenseSequence: PropTypes.func.isRequired,
  addToCartAvailable: PropTypes.bool.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  isSiRNASelected: PropTypes.bool.isRequired,
  isJapan: PropTypes.bool
};

export default OligosFormComponent;
